import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/app/cms_public/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/cms_public/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/app/cms_public/layouts/login.vue").then(m => m.default || m))
}